<template>
  <article v-if="modelValue.HasClauses" id="clauses" data-test-policy-clauses>
    <h2 data-test-policy-clauses-label v-html="modelValue.ClausesHeadline" />

    <span v-for="(clause, index) in modelValue.Clauses" :key="index">
      <strong v-html="clause.Title" />
      <p v-html="clause.Text" />
    </span>
  </article>
</template>

<script>
export default {
  name: 'Clauses',
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};
</script>
